export default {"src":"/_next/static/media/temporary-placeholder-graph-small.fd49784f.svg","height":210,"width":571};